module.exports = __webpack_public_path__ + "img/7D.6c213afc.png";